import React from 'react';
import {ErrorPage} from './ErrorPage';
import type {CourseId} from 'types/common';
import {useTranslateFunction} from 'contexts/translation/TranslationContext';

interface NoAccessProps {
  /**
   * The message to display on the error page. If a custom message is provided,
   * the CALLER is responsible for translating it.
   */
  message?: string | React.ReactNode;
  /**
   * The course ID to navigate to if the user is not signed in. If not provided,
   * will default to the current course ID. Only necessary for local development.
   */
  courseId?: CourseId;
}

/**
 * A component that displays a message indicating that the user does not have access to the page.
 */
export const NoAccess = ({message, courseId}: NoAccessProps) => {
  const t = useTranslateFunction('miscUI');
  const displayedMessage = message ?? t('You do not have access to this page.');
  return (
    <ErrorPage
      title={t('No Access')}
      msg={displayedMessage}
      courseId={courseId}
    />
  );
};

export default NoAccess;
